"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationPopover = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelHelpers_1 = require("../LabelHelpers");
const LabelAssetContent_1 = require("../shared/LabelAssetContent");
const LabelPopoverDetail_1 = require("../shared/LabelPopoverDetail");
const LabelType_1 = require("../shared/LabelType");
const Styles_1 = require("../Styles");
function CertificationAnchoredSection(_a) {
    var { anchored } = _a, props = tslib_1.__rest(_a, ["anchored"]);
    if (!anchored || anchored.labels.length < 1) {
        return null;
    }
    const { contentType } = props.content;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Styles_1.LabelGroupHeadingDiv, null, (0, LabelAssetContent_1.onThisAssetMessage)(contentType)),
        react_1.default.createElement(LabelPopoverDetail_1.ExpandoWidgetWrapper, { length: anchored === null || anchored === void 0 ? void 0 : anchored.labels.length, labelType: LabelType_1.LabelType[LabelType_1.LabelType.CERTIFIED] },
            react_1.default.createElement(RenderAnchoredAssetsCertifications, Object.assign({ anchored: anchored }, props)))));
}
function RenderAnchoredAssetsCertifications(_a) {
    var { anchored } = _a, props = tslib_1.__rest(_a, ["anchored"]);
    const { linksDisabled } = react_1.default.useContext(LabelHelpers_1.LabelButtonContext);
    if (!(anchored === null || anchored === void 0 ? void 0 : anchored.labels) || (anchored === null || anchored === void 0 ? void 0 : anchored.labels.length) < 1) {
        return null;
    }
    const { contentName, contentType, contentUrl, remoteType } = props.content;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Styles_1.LabelLabelsGroupDiv, null,
            react_1.default.createElement(LabelPopoverDetail_1.TextLinkWidgetLabelDetailAsset, { assetName: contentName !== null && contentName !== void 0 ? contentName : null, assetType: contentType !== null && contentType !== void 0 ? contentType : null, assetUrl: linksDisabled ? null : (contentUrl !== null && contentUrl !== void 0 ? contentUrl : null), remoteType: remoteType !== null && remoteType !== void 0 ? remoteType : undefined }),
            react_1.default.createElement(RenderCertifications, { assetName: contentName !== null && contentName !== void 0 ? contentName : null, certifications: anchored === null || anchored === void 0 ? void 0 : anchored.labels }))));
}
function RenderCertifications(props) {
    const { category } = react_1.default.useContext(LabelHelpers_1.LabelsPopoverContext);
    const { assetName, certifications } = props;
    return (react_1.default.createElement(react_1.default.Fragment, { key: props.keyIndex }, certifications.map((i, index) => (react_1.default.createElement(react_1.default.Fragment, { key: index },
        react_1.default.createElement(LabelPopoverDetail_1.LabelDetailMessageElement, Object.assign({}, i, { assetName: assetName })),
        react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAuthorElement, Object.assign({}, i, { category: category })),
        react_1.default.createElement(LabelPopoverDetail_1.LabelDetailDateElement, Object.assign({}, i)))))));
}
function CertificationParentedSection({ parented }) {
    if (!parented || parented.labels.length < 1) {
        return null;
    }
    const copy = parented.labels.map(i => i);
    const labelsMap = (0, LabelHelpers_1.groupBy)(copy, i => { var _a, _b; return (_b = (_a = i.content) === null || _a === void 0 ? void 0 : _a.contentId) !== null && _b !== void 0 ? _b : ''; });
    const groupedAssetLabels = [];
    labelsMap.forEach((value) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return groupedAssetLabels.push({
            subjectArea: (_b = (_a = value[0].content) === null || _a === void 0 ? void 0 : _a.subjectArea) !== null && _b !== void 0 ? _b : null,
            assetName: (_d = (_c = value[0].content) === null || _c === void 0 ? void 0 : _c.contentName) !== null && _d !== void 0 ? _d : null,
            assetType: (_f = (_e = value[0].content) === null || _e === void 0 ? void 0 : _e.contentType) !== null && _f !== void 0 ? _f : null,
            assetUrl: (_h = (_g = value[0].content) === null || _g === void 0 ? void 0 : _g.contentUrl) !== null && _h !== void 0 ? _h : null,
            remoteType: (_k = (_j = value[0].content) === null || _j === void 0 ? void 0 : _j.remoteType) !== null && _k !== void 0 ? _k : undefined,
            category: 'certification',
            categoryType: 'certification',
            labels: value,
        });
    });
    return (react_1.default.createElement(Styles_1.LabelAssetChildGroupDiv, null, groupedAssetLabels.map((c, i) => {
        var _a;
        return (react_1.default.createElement(Styles_1.LabelAssetGroupDiv, { key: i },
            react_1.default.createElement(LabelPopoverDetail_1.TextLinkWidgetLabelDetailAsset, { assetName: c.assetName, assetType: c.assetType, assetUrl: c.assetUrl, remoteType: c.remoteType }),
            react_1.default.createElement(Styles_1.LabelLabelsGroupDiv, null,
                react_1.default.createElement(RenderCertifications, { assetName: (_a = c.assetName) !== null && _a !== void 0 ? _a : null, certifications: c.labels, keyIndex: `${i}` }))));
    })));
}
function CertificationPopover(props) {
    return (props.anchored ? react_1.default.createElement(CertificationAnchoredSection, Object.assign({}, props)) : react_1.default.createElement(CertificationParentedSection, Object.assign({}, props)));
}
exports.CertificationPopover = CertificationPopover;
//# sourceMappingURL=CertificationPopover.js.map